export default __webpack_public_path__ + "static/media/closeIcon.942d1b17.svg";